import {bootstrapApplication} from '@angular/platform-browser';

import {AppComponent} from './apps/dpp/app.component';
import {appConfig} from './apps/dpp/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
